import { useStrictLocalization } from "@faire/web/common/localization";
export var useLoggedOutRetailerNodes = function useLoggedOutRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var loggedOutRetailerNodes = {
    L1: {
      Account: strictLocalize({
        id: "8viWk0",
        defaultMessage: [{
          "type": 0,
          "value": "Paramètres du compte (par exemple, mise à jour de l'adresse)"
        }]
      }),
      HowFaireWork: strictLocalize({
        id: "6TLwqu",
        defaultMessage: [{
          "type": 0,
          "value": "Comment fonctionne Faire ?"
        }]
      }),
      Invoices: strictLocalize({
        id: "t1H2TU",
        defaultMessage: [{
          "type": 0,
          "value": "Factures et paiements"
        }]
      }),
      Items: strictLocalize({
        id: "1qDrDS",
        defaultMessage: [{
          "type": 0,
          "value": "Articles manquants et endommagés"
        }]
      }),
      Orders: strictLocalize({
        id: "9QHKE5",
        defaultMessage: [{
          "type": 0,
          "value": "Statut de la commande"
        }]
      }),
      Returns: strictLocalize({
        id: "Gi6QMt",
        defaultMessage: [{
          "type": 0,
          "value": "Retours et remboursements"
        }]
      }),
      GeneralShipping: strictLocalize({
        id: "ueCCEa",
        defaultMessage: [{
          "type": 0,
          "value": "Questions générales sur l'expédition"
        }]
      }),
      Other: strictLocalize({
        id: "8PmlMt",
        defaultMessage: [{
          "type": 0,
          "value": "Autres problèmes concernant un commerçant"
        }]
      })
    },
    L2: {
      ImportFeesAndDuties: strictLocalize({
        id: "Fjt2kE",
        defaultMessage: [{
          "type": 0,
          "value": "Droits de douane"
        }]
      }),
      BuyingInternational: strictLocalize({
        id: "16zI+k",
        defaultMessage: [{
          "type": 0,
          "value": "Acheter à l'international"
        }]
      }),
      Other: strictLocalize({
        id: "mTbErA",
        defaultMessage: [{
          "type": 0,
          "value": "Autre"
        }]
      })
    }
  };
  return loggedOutRetailerNodes;
};